import { useRootSelector } from '../../../../../../store/hooks';
import { selectSitePricingProductsData } from '../../../../store/features/products';
import { PricingProduct } from '../../../../store/features/products/types';
import { SelectionProductId } from '../../../../hooks/selectPackage/usePackageSelectionHandlers';
import Typography from '../../../../shared/library/Typography';
import { PricingProductsProductTypeLayouts } from '../../../../types/enums';
import PrimaryProductsGroup from './PrimaryProductsGroup';

import { StyledProductTypeWrapper } from './styles';

export interface PackageSelectionPanelProps {
  onClickPrimaryProduct: (
    isSecondLevelAvailable: boolean,
    product: PricingProduct,
    productIndex: number,
  ) => void;
  onCollapsePrimaryProduct: (
    product: PricingProduct,
    productIndex: number,
  ) => void;
  selectedProductId?: SelectionProductId;
  addedToBasketProductId?: SelectionProductId;
}

export default function PackageSelectionPanel(
  props: PackageSelectionPanelProps,
) {
  const {
    onClickPrimaryProduct,
    onCollapsePrimaryProduct,
    selectedProductId,
    addedToBasketProductId,
  } = props;

  const {
    productTypesWithProducts,
    productTypeLayout = PricingProductsProductTypeLayouts.LIST,
  } = useRootSelector(selectSitePricingProductsData);
  const showProductType =
    productTypeLayout ===
    PricingProductsProductTypeLayouts.PRODUCTS_WITH_PRODUCT_TYPES;

  return (
    <div className="informa-payment-select-package-panel">
      {productTypesWithProducts.map((productTypeData, productTypeDataIndex) => {
        const { products, name, productTypeId } = productTypeData;
        const isFirstProductsGroup = productTypeDataIndex === 0;

        return (
          <StyledProductTypeWrapper
            withProductTypeName={showProductType}
            key={productTypeId}
            className="informa-payment-product-group"
            data-testid="primary-product-group-wrapper"
          >
            {showProductType && (
              <Typography
                variant="h3"
                paletteColorName="brandAccent"
                mb={2}
                className="informa-payment-product-group__title"
              >
                {name}
              </Typography>
            )}
            <PrimaryProductsGroup
              products={products}
              isFirstProductsGroup={isFirstProductsGroup}
              isShownProductType={showProductType}
              onClickPrimaryProduct={onClickPrimaryProduct}
              onCollapsePrimaryProduct={onCollapsePrimaryProduct}
              selectedProductId={selectedProductId}
              addedToBasketProductId={addedToBasketProductId}
            />
          </StyledProductTypeWrapper>
        );
      })}
    </div>
  );
}
